(function () {
  var PUBLIC_KEY = "R2h88j";

  var PATH_MAP = {
    "fr-be":"fr-BE", "fr-ch":"fr-CH", "fr-drom":"fr-DROM",
    "de-at":"de-AT", "de-ch":"de-CH",
    "nl-be":"nl-BE",
    "en":"en-EN",
    "en-ww":"en-WW", "en-eu":"en-EU", "en-us":"en-US"
  };
  var DOMAIN_MAP = {
    "ker-sun.de":"de-DE", "ker-sun.nl":"nl-NL", "ker-sun.co.uk":"en-GB",
    "ker-sun.it":"it-IT", "ker-sun.es":"es-ES", "ker-sun.dk":"da-DK", "ker-sun.se":"sv-SE"
  };
  var DEFAULT_MARKET = "fr-FR";
  var INVALID_LOCALE = { "fr-DROM":1, "en-WW":1, "en-EU":1, "en-EN":1 };

  function detectMarket() {
    var host = location.hostname.replace(/^www\./, "").toLowerCase();
    var seg = (location.pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
    if (PATH_MAP[seg]) return PATH_MAP[seg];
    if (DOMAIN_MAP[host]) return DOMAIN_MAP[host];
    return DEFAULT_MARKET;
  }
  var market = detectMarket();
  var lang = market.split("-")[0];

  /* Lien Politique de confidentialite, en respectant le prefixe de marche
     present dans l'URL (ex: /fr-drom/policies/...). Sur les marches par
     domaine (ker-sun.de...) il n'y a pas de prefixe -> lien racine. */
  var __seg = (location.pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
  var policyUrl = (PATH_MAP[__seg] ? "/" + __seg : "") + "/policies/privacy-policy";

  var I18N = {
    fr: { cta:"Recevoir une alerte", title:"Cet article <span class='bis-accent'>revient bientôt</span>", desc:"Indiquez votre e-mail et nous vous avertirons dès son retour en stock.", placeholder:"Votre adresse e-mail", submit:"Recevoir une alerte", okTitle:"Merci !", okText:"Nous vous enverrons un e-mail dès le retour en stock de cet article.", okBtn:"Poursuivre mes achats", invalid:"Merci d'entrer un e-mail valide.", error:"Une erreur est survenue, réessayez.", consent:"En poursuivant, vous acceptez notre {link}.", policy:"Politique de confidentialité" },
    es: { cta:"Recibir una alerta", title:"Este artículo <span class='bis-accent'>vuelve pronto</span>", desc:"Introduce tu e-mail y te avisaremos en cuanto vuelva a estar disponible.", placeholder:"Tu dirección de e-mail", submit:"Recibir una alerta", okTitle:"¡Gracias!", okText:"Te enviaremos un e-mail en cuanto este artículo vuelva a estar en stock.", okBtn:"Seguir comprando", invalid:"Introduce un email válido.", error:"Se ha producido un error, inténtalo de nuevo.", consent:"Al continuar, aceptas nuestra {link}.", policy:"Política de privacidad" },
    en: { cta:"Get an alert", title:"This item is <span class='bis-accent'>coming back soon</span>", desc:"Enter your e-mail and we'll notify you as soon as it's back in stock.", placeholder:"Your e-mail address", submit:"Get an alert", okTitle:"Thank you!", okText:"We'll email you as soon as this item is back in stock.", okBtn:"Continue shopping", invalid:"Please enter a valid email.", error:"Something went wrong, please try again.", consent:"By continuing, you accept our {link}.", policy:"Privacy Policy" },
    de: { cta:"Benachrichtigung erhalten", title:"Dieser Artikel ist <span class='bis-accent'>bald wieder da</span>", desc:"Geben Sie Ihre E-Mail-Adresse ein und wir benachrichtigen Sie, sobald der Artikel wieder verfügbar ist.", placeholder:"Ihre E-Mail-Adresse", submit:"Benachrichtigung erhalten", okTitle:"Danke!", okText:"Wir senden Ihnen eine E-Mail, sobald dieser Artikel wieder auf Lager ist.", okBtn:"Weiter einkaufen", invalid:"Bitte geben Sie eine gültige E-Mail-Adresse ein.", error:"Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.", consent:"Indem Sie fortfahren, akzeptieren Sie unsere {link}.", policy:"Datenschutzrichtlinie" },
    nl: { cta:"Een melding ontvangen", title:"Dit artikel is <span class='bis-accent'>binnenkort terug</span>", desc:"Vul je e-mailadres in en we laten het je weten zodra het artikel weer op voorraad is.", placeholder:"Jouw e-mailadres", submit:"Een melding ontvangen", okTitle:"Bedankt!", okText:"We sturen je een e-mail zodra dit artikel weer op voorraad is.", okBtn:"Verder winkelen", invalid:"Voer een geldig e-mailadres in.", error:"Er is iets misgegaan, probeer het opnieuw.", consent:"Door verder te gaan, ga je akkoord met ons {link}.", policy:"Privacybeleid" },
    it: { cta:"Ricevi un avviso", title:"Questo articolo <span class='bis-accent'>torna presto</span>", desc:"Inserisci la tua e-mail e ti avviseremo non appena l'articolo sarà di nuovo disponibile.", placeholder:"Il tuo indirizzo e-mail", submit:"Ricevi un avviso", okTitle:"Grazie!", okText:"Ti invieremo un'e-mail non appena questo articolo sarà di nuovo in stock.", okBtn:"Continua lo shopping", invalid:"Inserisci un indirizzo e-mail valido.", error:"Si è verificato un errore, riprova.", consent:"Continuando, accetti la nostra {link}.", policy:"Informativa sulla privacy" },
    sv: { cta:"Få en avisering", title:"Den här artikeln är <span class='bis-accent'>snart tillbaka</span>", desc:"Ange din e-postadress så meddelar vi dig så snart varan finns i lager igen.", placeholder:"Din e-postadress", submit:"Få en avisering", okTitle:"Tack!", okText:"Vi mejlar dig så snart den här varan finns i lager igen.", okBtn:"Fortsätt handla", invalid:"Ange en giltig e-postadress.", error:"Något gick fel, försök igen.", consent:"Genom att fortsätta godkänner du vår {link}.", policy:"integritetspolicy" },
    da: { cta:"Få besked", title:"Denne vare er <span class='bis-accent'>snart tilbage</span>", desc:"Indtast din e-mail, så giver vi dig besked, så snart varen er på lager igen.", placeholder:"Din e-mailadresse", submit:"Få besked", okTitle:"Tak!", okText:"Vi sender dig en e-mail, så snart denne vare er på lager igen.", okBtn:"Fortsæt med at handle", invalid:"Indtast en gyldig e-mailadresse.", error:"Noget gik galt, prøv igen.", consent:"Ved at fortsætte accepterer du vores {link}.", policy:"privatlivspolitik" }
  };
  var t = I18N[lang] || I18N.fr;

  /* Libelles du cas "ne reviendra pas" (redirection vers produits similaires). */
  var SIM = {
    fr:{cta:"Voir des produits similaires",ctaShort:"Produits similaires",note:"Cet article est en fin de série et ne sera pas réapprovisionné."},
    es:{cta:"Ver productos similares",ctaShort:"Productos similares",note:"Este artículo es de fin de serie y no se repondrá."},
    en:{cta:"View similar products",ctaShort:"Similar products",note:"This item is end-of-line and won't be restocked."},
    de:{cta:"Ähnliche Produkte ansehen",ctaShort:"Ähnliche Produkte",note:"Dieser Artikel ist ein Auslaufmodell und wird nicht nachbestellt."},
    nl:{cta:"Bekijk vergelijkbare producten",ctaShort:"Vergelijkbare producten",note:"Dit artikel is een aflopend product en wordt niet opnieuw aangevuld."},
    it:{cta:"Vedi prodotti simili",ctaShort:"Prodotti simili",note:"Questo articolo è fuori produzione e non sarà riassortito."},
    sv:{cta:"Visa liknande produkter",ctaShort:"Liknande produkter",note:"Den här varan utgår och fylls inte på igen."},
    da:{cta:"Se lignende produkter",ctaShort:"Lignende produkter",note:"Denne vare udgår og bliver ikke genbestilt."}
  };
  var ts = SIM[lang] || SIM.fr;

  /* Donnees produit exposees par le snippet Liquid (main-product.liquid) :
     - __BIS_WILL_RESTOCK : le produit porte le tag "retour-stock" (reviendra) ;
     - __BIS_ALL_OOS      : produit entierement epuise (toutes les tailles) ;
     - __BIS_SIMILAR_PATH : chemin de redirection (collection genre + tag usage). */
  var willRestock = window.__BIS_WILL_RESTOCK === true;
  var allOOS = window.__BIS_ALL_OOS === true;
  var similarPath = window.__BIS_SIMILAR_PATH || "";
  var similarUrl = similarPath ? ((PATH_MAP[__seg] ? "/" + __seg : "") + similarPath) : "";
  var bisMode = "none"; /* none | notify | similar */

  var cta = null, modal = null, variantInput = null, stickyCta = null;
  var settled = false; /* true une fois la page stabilisee : on lit alors toujours l'etat reel du bouton */

  function injectStyles() {
    if (document.getElementById("bis-styles")) return;
    var s = document.createElement("style"); s.id = "bis-styles";
    s.textContent = [
      "#bis-cta{display:block;width:100%;min-height:60px;padding:18px 26px;background:#005670;color:#F2EFE9;border:none;border-radius:60px;font-family:'Work Sans',sans-serif;font-size:16px;font-weight:500;line-height:1;cursor:pointer;text-align:center}",
      "#bis-cta[hidden]{display:none}",
      ".bis-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center}",
      ".bis-modal[hidden]{display:none}",
      ".bis-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.5)}",
      ".bis-modal__box{position:relative;background:#F2EFE9;border-radius:16px;padding:40px;max-width:480px;width:90%;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.2);font-family:'Work Sans',sans-serif}",
      ".bis-modal__close{position:absolute;top:14px;right:16px;background:none;border:none;font-size:28px;line-height:1;cursor:pointer;color:#111}",
      ".bis-modal__box h2{font-size:24px;font-weight:600;margin:0 0 14px;color:#000;font-family:'Work Sans',sans-serif}",
      ".bis-modal__box p{margin:0 0 20px;color:#3a3a3a;font-size:15px;line-height:1.5}",
      ".bis-modal__box input[type=email]{width:100%;padding:15px 16px;border:1px solid #d8d2c6;border-radius:10px;font-size:16px;background:#fff;box-sizing:border-box;margin-bottom:14px;font-family:'Work Sans',sans-serif}",
      "#bis-submit,#bis-continue{display:block;width:100%;min-height:60px;padding:18px 26px;background:#005670;color:#F2EFE9;border:none;border-radius:60px;font-family:'Work Sans',sans-serif;font-size:16px;font-weight:500;line-height:1;cursor:pointer}",
      "@media(max-width:768px){#bis-cta-sticky{font-size:10px !important;padding-left:4px !important;padding-right:4px !important;white-space:nowrap !important}}",
      ".bis-accent{color:#00A3E0}",
      ".bis-modal__box .bis-consent{margin:36px 0 0;font-size:12px;line-height:1.45;color:#6b6b6b}",
      ".bis-consent a{color:#005670;text-decoration:underline}",
      "#bis-message{margin-top:12px;font-size:14px}",
      "#bis-cta[hidden],#bis-cta-sticky[hidden]{display:none !important}",
      "html.bis-oos .buy-buttons button[name=\"add\"]{display:none !important}",
      "html.bis-hide-add .buy-buttons button[name=\"add\"]{visibility:hidden !important}"
    ].join("");
    document.head.appendChild(s);
  }

  function hideAddButtons(hide) {
    /* Des qu'on a tranche, on retire le masquage provisoire "bis-hide-add"
       (pose des la 1ere image par le snippet) et on applique l'etat definitif. */
    document.documentElement.classList.remove("bis-hide-add");
    if (hide) document.documentElement.classList.add("bis-oos");
    else document.documentElement.classList.remove("bis-oos");
    document.querySelectorAll('button[name="add"]').forEach(function (b) { b.style.display = hide ? "none" : ""; });
  }
  function openModal() { if (modal) { modal.hidden = false; var em = modal.querySelector("#bis-email"); if (em) em.focus(); } }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    var f = modal.querySelector("#bis-form"), c = modal.querySelector("#bis-confirm");
    if (f && c) { f.hidden = false; c.hidden = true; }
    var em = modal.querySelector("#bis-email"); if (em) em.value = "";
    var m = modal.querySelector("#bis-message"); if (m) { m.hidden = true; m.textContent = ""; }
  }

  function ctaAction() {
    if (bisMode === "similar") { if (similarUrl) window.location.href = similarUrl; }
    else { openModal(); }
  }
  function applyMode(el) {
    if (!el) return;
    if (bisMode === "similar") {
      el.textContent = (el.id === "bis-cta-sticky" && ts.ctaShort) ? ts.ctaShort : ts.cta;
    } else {
      el.textContent = t.cta;
    }
  }
  function showCta(mode) {
    bisMode = mode;
    applyMode(cta); applyMode(stickyCta);
    if (cta) cta.hidden = false;
    if (stickyCta) stickyCta.hidden = false;
  }
  function hideCta() {
    bisMode = "none";
    if (cta) cta.hidden = true;
    if (stickyCta) stickyCta.hidden = true;
  }

  function ensureCta() {
    cta = document.getElementById("bis-cta");
    if (cta) return;
    cta = document.createElement("button");
    cta.type = "button"; cta.id = "bis-cta"; cta.hidden = true;
    cta.textContent = t.cta;
    cta.addEventListener("click", ctaAction);
    var buyButtons = document.querySelector(".buy-buttons");
    if (buyButtons) { buyButtons.appendChild(cta); }
    else { var f = document.querySelector('form[action$="/cart/add"]'); if (f) { f.insertAdjacentElement("afterend", cta); } }
  }

  /* Sur le template classique (v4-0-product), il y a aussi un bouton "Ajouter
     au panier" COLLANT (.product-sticky-form__button). On lui adjoint un CTA
     "Me prevenir" qui reprend son apparence et ouvre la meme pop-up. */
  function ensureStickyCta() {
    stickyCta = document.getElementById("bis-cta-sticky");
    if (stickyCta) return;
    var nativeSticky = document.querySelector(".product-sticky-form__button");
    if (!nativeSticky) return; /* pas de barre collante sur ce template */
    stickyCta = document.createElement("button");
    stickyCta.type = "button"; stickyCta.id = "bis-cta-sticky"; stickyCta.hidden = true;
    stickyCta.textContent = t.cta;
    stickyCta.className = nativeSticky.className; /* meme look que le bouton sticky natif */
    stickyCta.style.fontSize = "16px"; /* desktop : taille d'origine inchangee (le mobile est gere via @media plus bas) */
    /* Quand l'article est epuise, le theme desactive souvent la zone d'achat
       collante (pointer-events:none). On force notre CTA a rester cliquable. */
    stickyCta.style.setProperty("pointer-events", "auto", "important");
    stickyCta.style.cursor = "pointer";
    stickyCta.disabled = false;
    /* Un accordeon de la page se peignait par-dessus le bouton et captait le
       clic : on remonte le CTA (et la barre collante) au-dessus du contenu,
       tout en restant sous la pop-up (99999). On ne touche pas a la position
       pour ne pas casser le comportement collant du theme. */
    stickyCta.style.setProperty("z-index", "9999", "important");
    var stickyBar = nativeSticky.closest(".product-sticky-form") || nativeSticky.closest("[class*='sticky']");
    if (stickyBar) stickyBar.style.setProperty("z-index", "9998", "important");
    stickyCta.addEventListener("click", ctaAction);
    nativeSticky.insertAdjacentElement("afterend", stickyCta);
    /* Un element (accordeon <summary>) se peint par-dessus le bouton sticky et
       capte le clic ; comme il est dans un autre contexte d'empilement, le
       z-index ne suffit pas. On intercepte donc le clic au niveau du document
       en phase de CAPTURE (avant qu'il n'atteigne le <summary>) : si le clic
       tombe dans la zone de notre bouton sticky visible, on ouvre la pop-up et
       on stoppe l'evenement. Deterministe, et limite a la zone du bouton. */
    if (!window.__bisStickyClick) {
      window.__bisStickyClick = true;
      document.addEventListener("click", function (e) {
        var btn = document.getElementById("bis-cta-sticky");
        if (!btn || btn.hidden) return;
        var r = btn.getBoundingClientRect();
        if (!r.width || !r.height) return; /* pas affiche */
        if (e.clientX >= r.left && e.clientX <= r.right &&
            e.clientY >= r.top && e.clientY <= r.bottom) {
          e.preventDefault();
          e.stopPropagation();
          ctaAction();
        }
      }, true);
    }
    /* Le menu deroulant custom de la barre sticky ignore les clics sur les
       tailles epuisees (items marques .is-unavailable). On intercepte ce clic
       et on le route vers le bouton radio principal de cette taille : le theme
       met alors tout a jour (prix, bouton principal -> notre CTA, et la barre
       sticky qui se resynchronise). On emprunte la mecanique du theme. */
    if (!window.__bisStickyItemClick) {
      window.__bisStickyItemClick = true;
      document.addEventListener("click", function (e) {
        var item = e.target.closest && e.target.closest("[data-sticky-select-item]");
        if (!item || !item.classList.contains("is-unavailable")) return; /* le theme gere deja les tailles dispo */
        var size = item.getAttribute("data-option-value");
        if (!size) return;
        var safe = (window.CSS && CSS.escape) ? CSS.escape(size) : size.replace(/"/g, '\\"');
        var radio = document.querySelector('input[name="Taille"][value="' + safe + '"]')
                 || document.querySelector('input[type="radio"][value="' + safe + '"]');
        if (!radio) return;
        e.preventDefault();
        e.stopPropagation();
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        /* refermer le menu deroulant sticky s'il est ouvert */
        var ddBtn = document.querySelector("[data-sticky-select-button][aria-expanded='true']");
        if (ddBtn) ddBtn.click();
        refresh();
      }, true);
    }
  }

  function buildModal() {
    if (modal) return;
    modal = document.createElement("div");
    modal.className = "bis-modal"; modal.hidden = true;
    modal.innerHTML =
      '<div class="bis-modal__overlay" data-bis-close></div>' +
      '<div class="bis-modal__box" role="dialog" aria-modal="true">' +
        '<button type="button" class="bis-modal__close" data-bis-close aria-label="X">&times;</button>' +
        '<div id="bis-form">' +
          '<h2>' + t.title + '</h2>' +
          '<p>' + t.desc + '</p>' +
          '<input type="hidden" id="bis-variant-id">' +
          '<input type="email" id="bis-email" placeholder="' + t.placeholder + '" required>' +
          '<button type="button" id="bis-submit">' + t.submit + '</button>' +
          '<p class="bis-consent">' + t.consent.replace("{link}", '<a href="' + policyUrl + '" target="_blank" rel="noopener">' + t.policy + '</a>') + '</p>' +
          '<p id="bis-message" hidden></p>' +
        '</div>' +
        '<div id="bis-confirm" hidden>' +
          '<h2>' + t.okTitle + '</h2>' +
          '<p>' + t.okText + '</p>' +
          '<button type="button" id="bis-continue">' + t.okBtn + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    variantInput = modal.querySelector("#bis-variant-id");
    modal.querySelectorAll("[data-bis-close]").forEach(function (el) { el.addEventListener("click", closeModal); });
    modal.querySelector("#bis-submit").addEventListener("click", subscribe);
    modal.querySelector("#bis-continue").addEventListener("click", closeModal);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });
  }

  function currentVariantId() {
    var input = document.querySelector('form[action$="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
    return input ? input.value : null;
  }
  /* Etat du bouton d'achat :
     true  = epuise (texte type "En rupture de stock" / "Epuise")
     false = en stock
     null  = indetermine (bouton desactive SANS texte d'epuisement = chargement
             pendant un changement de variante) -> on ne touche a rien pour
             eviter le flash du CTA. */
  function stockState() {
    var add = document.querySelector('.buy-buttons button[name="add"]') || document.querySelector('button[name="add"]');
    if (!add) return null;
    var txt = (add.textContent || "").toLowerCase();
    if (/sold ?out|puis|agotado|rupture|ausverkauft|esaurito|uitverkocht|slut|udsolgt/.test(txt)) return true;
    if (add.disabled) return null; /* desactive mais pas "epuise" = en cours de chargement */
    return false;
  }
  function refresh() {
    if (!cta) return;
    var id = currentVariantId();
    if (id && variantInput) variantInput.value = id;

    /* Source de verite = l'etat reel du bouton d'achat pour la variante
       SELECTIONNEE. On ne montre le CTA que si cette variante est epuisee ; des
       que le client choisit une taille disponible, on revient a "Ajouter". */
    var oos = stockState();

    /* Anti-flash AU CHARGEMENT uniquement : si la taille memorisee du client est
       epuisee, on affiche le CTA tout de suite (sans attendre la restauration de
       la taille par le theme), mais SEULEMENT tant que la page n'est pas
       stabilisee. Une fois "settled", on lit toujours l'etat reel -> le
       changement de taille fonctionne normalement. */
    if (!settled && window.__BIS_SAVED_OOS === true) {
      oos = true;
      if (window.__BIS_SAVED_VID && variantInput) variantInput.value = String(window.__BIS_SAVED_VID);
    }
    if (oos === null) return; /* bouton en cours de chargement : on ne touche a rien */

    if (oos) {
      if (willRestock) { hideAddButtons(true); showCta("notify"); }   /* reviendra -> alerte e-mail */
      else { hideAddButtons(true); showCta("similar"); }              /* ne reviendra pas -> produits similaires (taille seule OU tout epuise) */
    } else {
      hideAddButtons(false); hideCta();
    }
  }
  function init() {
    if (window.__bisInit) return; /* evite la double-initialisation (page:loaded + DOMContentLoaded) */
    window.__bisInit = true;
    window.__bisReady = true;
    injectStyles(); buildModal(); ensureCta(); ensureStickyCta();
    refresh();
    /* Apres une courte fenetre, la page est consideree stabilisee : fin de
       l'anti-flash initial, on lit toujours l'etat reel du bouton. */
    setTimeout(function () { settled = true; refresh(); }, 1000);
    if (!window.__bisPoll) window.__bisPoll = setInterval(refresh, 400);
    if (!window.__bisObs && window.MutationObserver) {
      var host = document.querySelector(".buy-buttons") || document.querySelector('form[action$="/cart/add"]') || document.body;
      window.__bisObs = new MutationObserver(function () {
        if (window.__bisRaf) return;
        window.__bisRaf = requestAnimationFrame(function () { window.__bisRaf = 0; refresh(); });
      });
      window.__bisObs.observe(host, { childList: true, subtree: true, characterData: true, attributes: true });
    }
  }

  async function subscribe() {
    var email = modal.querySelector("#bis-email").value.trim();
    var msg = modal.querySelector("#bis-message");
    var variantId = variantInput.value;
    if (!email || email.indexOf("@") === -1) { msg.textContent = t.invalid; msg.hidden = false; return; }
    /* Titre du produit dans la langue de la page (expose dans theme.liquid via product.title)
       + taille de la variante selectionnee (map id -> option1 exposee dans theme.liquid). */
    var productTitle = window.__BIS_PRODUCT_TITLE || "";
    var variantName = (window.__BIS_SIZES_BY_ID && window.__BIS_SIZES_BY_ID[variantId]) || "";
    var productImage = window.__BIS_PRODUCT_IMAGE || "";
    var profileAttrs = { email: email, properties: { Language: market } };
    if (!INVALID_LOCALE[market]) profileAttrs.locale = market;
    try {
      await fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + PUBLIC_KEY, {
        method: "POST", headers: { "Content-Type": "application/json", "revision": "2026-01-15" },
        body: JSON.stringify({ data: { type: "back-in-stock-subscription", attributes: {
          profile: { data: { type: "profile", attributes: { email: email } } }, channels: ["EMAIL"] },
          relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + variantId } } } } })
      });
      await fetch("https://a.klaviyo.com/client/events/?company_id=" + PUBLIC_KEY, {
        method: "POST", headers: { "Content-Type": "application/json", "revision": "2026-01-15" },
        body: JSON.stringify({ data: { type: "event", attributes: {
          properties: { market: market, variant_id: variantId, product_title: productTitle, variant_name: variantName, product_image: productImage },
          metric: { data: { type: "metric", attributes: { name: "BIS Subscribed" } } },
          profile: { data: { type: "profile", attributes: profileAttrs } } } } })
      });
      modal.querySelector("#bis-form").hidden = true;
      modal.querySelector("#bis-confirm").hidden = false;
    } catch (e) { msg.textContent = t.error; msg.hidden = false; console.error(e); }
  }

  document.addEventListener("variant:change", function () { settled = true; refresh(); });
  document.addEventListener("page:loaded", init);
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();